module.exports = __webpack_public_path__ + "img/jt.9265af63.png";